function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SouthKoreaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#3D58DB",
        fillRule: "evenodd",
        d: "M11.84 16.929c2.562 0 4.64-2.127 4.64-4.751 0-2.624-2.078-4.751-4.64-4.751S7.2 9.554 7.2 12.177c0 2.625 2.078 4.752 4.64 4.752Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("mask", {
        id: "c",
        width: "10",
        height: "10",
        x: "7",
        y: "7",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M11.84 16.929c2.562 0 4.64-2.127 4.64-4.751 0-2.624-2.078-4.751-4.64-4.751S7.2 9.554 7.2 12.177c0 2.625 2.078 4.752 4.64 4.752Z",
          clipRule: "evenodd"
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: "url(#c)",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#E31D1C",
          fillRule: "evenodd",
          d: "M16.642 12.542s-.26-2.24-2.19-2.362c-1.928-.122-2.448 1.643-2.56 2.11-.11.468-.392 1.715-2.423 1.715-2.03 0-2.213-3.171-2.213-3.171v-3.74h9.386v5.448Z",
          clipRule: "evenodd"
        })
      }), /*#__PURE__*/_jsx("path", {
        fill: "#272727",
        fillRule: "evenodd",
        d: "m5.474 4.54.687.62-3.18 3.714-.687-.621 3.18-3.714Zm1.132 1.003.686.621-3.066 3.66-.686-.62 3.066-3.66ZM8.42 7.181l-.686-.62-3.075 3.687.686.62L8.42 7.182Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#272727",
        d: "m6.16 5.16.058.049.047-.056-.054-.049-.05.056Zm-.686-.62.05-.056-.056-.052-.05.058.056.05ZM2.982 8.873l-.05.055.056.052.05-.059-.056-.048Zm-.687-.621-.057-.049-.047.056.054.049.05-.056Zm4.998-2.089.058.048.046-.055-.053-.048-.05.055Zm-.686-.62.05-.056-.057-.052-.05.06.057.047Zm-2.38 4.28-.05.056.058.052.05-.06-.058-.048Zm-.686-.62-.057-.049-.047.056.054.048.05-.055ZM7.733 6.56l.05-.055-.058-.053-.05.06.058.048Zm.686.62.058.049.046-.055-.054-.049-.05.056Zm-3.76 3.068L4.6 10.2l-.046.055.054.049.05-.056Zm.685.62-.05.056.058.053.05-.06-.058-.048Zm.867-5.764-.686-.62-.1.11.685.621.101-.11ZM3.037 8.922l3.18-3.713-.113-.098-3.18 3.714.114.097Zm-.793-.613.686.62.1-.11-.685-.622-.101.112ZM5.418 4.49l-3.18 3.714.113.098 3.18-3.714-.113-.098ZM7.343 6.11l-.686-.621-.101.111.686.62.1-.11Zm-3.06 3.763 3.067-3.66-.115-.096-3.066 3.66.115.096ZM3.49 9.26l.686.62.1-.11-.686-.621-.1.111Zm3.059-3.764-3.066 3.66.115.097 3.066-3.66-.115-.097Zm1.134 1.12.686.622.1-.112-.686-.62-.1.11Zm-2.967 3.681L7.79 6.608l-.115-.096L4.6 10.2l.116.096Zm.679.517-.687-.62-.1.11.686.621.1-.11Zm2.966-3.68L5.287 10.82l.115.096 3.075-3.688-.116-.096Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#272727",
        fillRule: "evenodd",
        d: "m18.439 4.54-.686.62 3.18 3.714.686-.621-3.18-3.714Zm-1.132 1.003-.686.621 3.066 3.66.686-.62-3.066-3.66Zm-1.813 1.638.686-.62 3.075 3.687-.686.62-3.075-3.687Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#272727",
        d: "m17.753 5.16-.057.049-.048-.056.054-.049.05.056Zm.686-.62-.05-.056.057-.052.05.058-.057.05Zm2.494 4.334.05.055-.057.052-.05-.059.057-.048Zm.686-.621.057-.049.048.056-.055.049-.05-.056Zm-4.998-2.089-.058.048-.046-.055.053-.048.05.055Zm.686-.62-.05-.056.057-.052.05.06-.057.047Zm2.38 4.28.05.056-.057.052-.05-.06.057-.048Zm.686-.62.058-.049.046.056-.053.048-.05-.055ZM16.18 6.56l-.05-.055.058-.053.05.06-.058.048Zm-.686.62-.057.049-.046-.055.053-.049.05.056Zm3.761 3.068.058-.048.046.055-.054.049-.05-.056Zm-.686.62.05.056-.058.053-.05-.06.058-.048Zm-.867-5.764.686-.62.101.11-.686.621-.1-.11Zm3.174 3.818-3.18-3.713.114-.098 3.18 3.714-.114.097Zm.793-.613-.686.62-.1-.11.686-.622.1.112ZM18.496 4.49l3.18 3.714-.114.098-3.18-3.714.114-.098ZM16.57 6.11l.686-.621.1.111-.686.62-.1-.11Zm3.059 3.763-3.067-3.66.115-.096 3.066 3.66-.114.096Zm.794-.613-.687.62-.1-.11.686-.621.1.111Zm-3.06-3.764 3.067 3.66-.115.097-3.066-3.66.115-.097Zm-1.133 1.12-.686.622-.101-.112.686-.62.1.11Zm2.967 3.681-3.075-3.688.115-.096 3.075 3.688-.115.096Zm-.68.517.687-.62.1.11-.686.621-.1-.11Zm-2.966-3.68 3.075 3.688-.116.096-3.074-3.688.115-.096Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#272727",
        fillRule: "evenodd",
        d: "m5.474 19.869.687-.62-3.18-3.715-.687.62 3.18 3.715Zm1.132-1.005.686-.62-3.066-3.66-.686.62 3.066 3.66Zm1.813-1.637-.686.62-3.075-3.687.686-.62 3.075 3.687Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#272727",
        d: "m6.16 19.248.058-.049.047.056-.054.049-.05-.056Zm-.686.62.05.056-.056.052-.05-.058.056-.05Zm-2.493-4.334-.05-.055.056-.052.05.058-.056.05Zm-.687.62-.057.05-.047-.056.054-.049.05.056Zm4.998 2.09.058-.048.046.055-.053.048-.05-.055Zm-.686.62.05.056-.057.052-.05-.06.057-.048Zm-2.38-4.28-.05-.056.058-.052.05.06-.058.048Zm-.686.62-.057.048-.047-.055.054-.048.05.055Zm4.193 2.644.05.055-.058.053-.05-.06.058-.048Zm.686-.621.058-.048.046.055-.054.049-.05-.056Zm-3.76-3.067-.059.048-.046-.056.054-.048.05.056Zm.685-.62-.05-.056.058-.053.05.06-.058.048Zm.867 5.764-.686.62-.1-.11.685-.622.101.112Zm-3.174-3.819 3.18 3.714-.113.098-3.18-3.714.114-.098Zm-.793.614.686-.62.1.11-.685.621-.101-.11Zm3.174 3.819-3.18-3.714.113-.098 3.18 3.714-.113.098Zm1.925-1.619-.686.621-.101-.111.686-.62.1.11Zm-3.06-3.763 3.067 3.66-.115.096-3.066-3.66.115-.096Zm-.793.613.686-.621.1.111-.686.62-.1-.11Zm3.059 3.764-3.066-3.66.115-.097 3.066 3.66-.115.097Zm1.134-1.12.686-.622.1.112-.686.62-.1-.11Zm-2.967-3.681L7.79 17.8l-.115.096L4.6 14.208l.116-.096Zm.679-.517-.687.62-.1-.11.686-.622.1.112Zm2.966 3.68-3.074-3.688.115-.096 3.075 3.688-.116.096Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#272727",
        fillRule: "evenodd",
        d: "m18.439 19.869-.686-.62 3.18-3.715.686.62-3.18 3.715Zm-1.132-1.005-.686-.62 3.066-3.66.686.62-3.066 3.66Zm-1.813-1.637.686.62 3.075-3.687-.686-.62-3.075 3.687Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#272727",
        d: "m17.753 19.248-.057-.049-.048.056.054.049.05-.056Zm.686.62-.05.056.057.052.05-.058-.057-.05Zm2.494-4.334.05-.055-.057-.052-.05.058.057.05Zm.686.62.057.05.048-.056-.055-.049-.05.056Zm-4.998 2.09-.058-.048-.046.055.053.048.05-.055Zm.686.62-.05.056.057.052.05-.06-.057-.048Zm2.38-4.28.05-.056-.057-.052-.05.06.057.048Zm.686.62.058.048.046-.055-.053-.048-.05.055Zm-4.193 2.644-.05.055.058.053.05-.06-.058-.048Zm-.686-.621-.057-.048-.046.055.053.049.05-.056Zm3.761-3.067.058.048.046-.056-.054-.048-.05.056Zm-.686-.62.05-.056-.058-.053-.05.06.058.048Zm-.867 5.764.686.62.101-.11-.686-.622-.1.112Zm3.174-3.819-3.18 3.714.114.098 3.18-3.714-.114-.098Zm.793.614-.686-.62-.1.11.686.621.1-.11Zm-3.173 3.819 3.18-3.714-.114-.098-3.18 3.714.114.098Zm-1.925-1.619.686.621.1-.111-.686-.62-.1.11Zm3.059-3.763-3.067 3.66.115.096 3.066-3.66-.114-.096Zm.794.613-.687-.621-.1.111.686.62.1-.11Zm-3.06 3.764 3.067-3.66-.115-.097-3.066 3.66.115.097Zm-1.133-1.12-.686-.622-.101.112.686.62.1-.11Zm2.967-3.681L16.123 17.8l.115.096 3.075-3.688-.115-.096Zm-.68-.517.687.62.1-.11-.686-.622-.1.112Zm-2.966 3.68 3.075-3.688-.116-.096-3.074 3.688.115.096Z"
      })]
    })]
  })]
}));
//# sourceMappingURL=SouthKorea.js.map